import { HttpClient, MergeDataCommon, AMCFundStatusUtil } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class CAMCFundOverview {
    constructor(fundCode, containerSelector) {
        this.$camcFundOverviewTable = $(containerSelector);
        this.httpClient = new HttpClient();
        this.fundCode = fundCode;
        this.fundOverviewUrl = FUND_API_SOURCES.FUND_SHARECLASS_SOURCE + this.fundCode;
    }

    async render() {
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
        };
        const fundOverviewData = await this.httpClient.get(this.fundOverviewUrl, options);
        options = {
            data: {
                fundCode: this.fundCode,
            },
        };
        try {
            this.fundManagerData = await this.httpClient.get(FUND_API_SOURCES.MANAGERS_SOURCE, options);
        } catch {
            this.fundManagerData = null;
        }
        this.displayFields = await this.handleData(fundOverviewData);
        this.renderFundOverview(this.displayFields);
    }

    async handleData(fundOverviewData) {
        const currencyCode = fundOverviewData.data?.currency;
        let displayCurrency = currencyCode;
        if (window.currencyMapping && currencyCode) {
            displayCurrency = window.currencyMapping[currencyCode] || currencyCode;
        }

        // Process the established date asynchronously
        const establishedDate = await this.isActiveFund(
            fundOverviewData.data?.establishedDate,
            fundOverviewData.data?.fundType[0].fundType,
        );

        const fields = [
            { selector: "#legal-name", data: fundOverviewData.data.fundName[1].shortName },
            { selector: "#fund-company", data: fundOverviewData.data.fundCompany },
            { selector: "#fund-custodian", data: fundOverviewData.data.custodianOnshore },
            {
                selector: "#established-date",
                data: establishedDate,
            },
            { selector: "#inv-obj", data: fundOverviewData.data?.invObj },
            { selector: "#inv-scope", data: fundOverviewData.data?.invScope },
            { selector: "#risk-char", data: fundOverviewData.data?.riskChar },
            { selector: "#fund-benchmark", data: fundOverviewData.data?.benchmarkName },
            { selector: "#currency", data: displayCurrency },
        ];
        return fields;
    }

    renderDataItem() {}

    errorHandler() {}

    async isActiveFund(value, fund_type) {
        if (fund_type == "MRF") {
            return value;
        }

        return (await AMCFundStatusUtil.getFundStatus()) ? MergeDataCommon.formatString(value) : "-";
    }
}

export default CAMCFundOverview;
